// v2 sign — a hanging shingle: a finial-topped post with a bracket arm and a
// knee brace, from which the written board swings on two iron straps — the
// village tavern-sign look, with a small painted emblem on the board. Builds
// fast, so it has no scaffolding. Ported 1:1 from age-of-mcp's v2/sign.ts, using
// the library's shared `foundationSlab` helper.
import * as THREE from "three";
import { defineModel, foundationSlab, type Part } from "../../lib";

const POST  = "#6e5230";
const ARM   = "#8a6b3c";
const BOARD = "#b9904f";
const IRON  = "#3c4046";

function post(h: number): Part {
  return { geometry: new THREE.BoxGeometry(0.05, h, 0.05), color: POST,
    position: [0, h / 2, 0] };
}

// The bracket arm reaching out over the street, at the post top.
function arm(): Part {
  return { geometry: new THREE.BoxGeometry(0.26, 0.04, 0.04), color: ARM,
    position: [0.13, 0.41, 0] };
}

function stage(s: number): Part[] {
  if (s <= 0) return [foundationSlab(0.18, 0.05)];
  if (s === 1) return [post(0.18)];
  if (s === 2) return [post(0.42), arm()];
  return [
    post(0.44),
    // Finial knob on the post top.
    { geometry: new THREE.IcosahedronGeometry(0.025, 0), color: POST,
      position: [0, 0.46, 0] },
    arm(),
    // Knee brace from the post up into the arm.
    { geometry: new THREE.BoxGeometry(0.025, 0.14, 0.025), color: ARM,
      position: [0.07, 0.35, 0], rotation: [0, 0, -0.81] },
    // Two iron straps the shingle hangs from.
    { geometry: new THREE.BoxGeometry(0.012, 0.06, 0.012), color: IRON,
      position: [0.08, 0.36, 0] },
    { geometry: new THREE.BoxGeometry(0.012, 0.06, 0.012), color: IRON,
      position: [0.20, 0.36, 0] },
    // The hanging board, with a painted emblem.
    { geometry: new THREE.BoxGeometry(0.20, 0.14, 0.025), color: BOARD,
      position: [0.14, 0.26, 0] },
    { geometry: new THREE.BoxGeometry(0.07, 0.07, 0.01), color: "#7a3b2e",
      position: [0.14, 0.26, 0.018] },
  ];
}

export const signV2 = defineModel({
  id: "sign-v2",
  tiles: { w: 1, h: 1 },
  batchId: "fable",
  name: "Sign (v2)",
  tags: ["building","sign","low-poly","age-of-mcp","fable"],
  summary: "Low-poly sign.",
  description: "A wooden board carrying one short written message.",
  author: "age-of-mcp",
  footprint: 0.13,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => stage(0) },
    { id: "stage-1", label: "Lower", parts: () => stage(1) },
    { id: "stage-2", label: "Upper", parts: () => stage(2) },
    { id: "complete", label: "Complete", parts: () => stage(3) },
  ],
  animations: [],
});
